module.exports = __webpack_public_path__ + "static/media/purchasefly-logo.0626cc5e.png";